//------------------------------------------------------------------------------
//  This code was generated by typescript template tool 'Typewriter'.
//
//  Changes to this file may cause incorrect behavior and will be lost if
//  the code is regenerated.
//------------------------------------------------------------------------------


import { Injectable } from "@angular/core";
//import { ResponseContentType, Response } from "@angular/http";
import { Observable } from 'rxjs';
import { BasApiService } from '../base.api.service';
import {GridApiService} from './grid.api.service';
import * as ApiTypes from "../../models";

@Injectable()
export class DepositApiService extends GridApiService<ApiTypes.DepositViewModel,ApiTypes.DepositViewFilterModels>{
  
  constructor(public baseService: BasApiService) {
   super(baseService);
    this.apiKey = "api/deposit";
  }
  
  save = (model: ApiTypes.DepositViewModel): Observable<void> =>
    this.baseService.post<void>(`api/Deposit/save`, model, {}, true, true);   
  
  }

